import ErrorIcon from "@mui/icons-material/Error";
import { CircularProgress, capitalize } from "@mui/material";
import type { ScenarioState } from "../types";
import { StatusChip, type StatusEntry } from "./ui/status-chip";

const STATUS_MAP: Partial<Record<ScenarioState, StatusEntry>> = {
  processing_error: {
    icon: <ErrorIcon sx={{ fontSize: 12 }} />,
    color: "error",
    variant: "filled",
  },
  discarded: {
    icon: <ErrorIcon sx={{ fontSize: 12 }} />,
    color: "error",
    variant: "filled",
  },
  pending: { color: "warning" },
  ready: { color: "info", variant: "outlined" },
  processing: {
    icon: <CircularProgress size={12} color="inherit" />,
    color: "primary",
    variant: "filled",
  },
  testing: {
    icon: <CircularProgress size={12} color="inherit" />,
    color: "primary",
    variant: "filled",
  },
  persisted: { color: "success", variant: "filled" },
  scheduled: { color: "default", variant: "outlined" },
};

const formatLabel = (s: string) => capitalize(s.replace(/_/g, " "));

type Props = {
  state: ScenarioState;
  variant?: "outlined" | "filled";
  size?: "small" | "medium";
};

export const ScenarioStateChip: React.FC<Props> = ({
  state,
  variant = "filled",
  size = "small",
}) => (
  <StatusChip
    status={state}
    statusMap={STATUS_MAP}
    formatLabel={formatLabel}
    variant={variant}
    size={size}
  />
);
